class Api {
  async getYearbookCards() {
    const response = await fetch(`${this._siteUrl}cards/yearbook`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
    });
    return this._checkResponse(response);
  }
  async updateUserPassword(userId, password) {
    const response = await fetch(`${this._siteUrl}users/${userId}/password`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
      body: JSON.stringify({ password }),
    });
    return this._checkResponse(response);
  }
  async setUserNotified(userId) {
    const response = await fetch(`${this._siteUrl}users/${userId}/notified`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
    });
    return this._checkResponse(response);
  }
  async sendEmail({ to, subject, html }) {
    const response = await fetch(`${this._siteUrl}send-email`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
      body: JSON.stringify({ to, subject, html }),
    });
    return this._checkResponse(response);
  }
  async getCardsByFamilyId(familyId) {
    const response = await fetch(`${this._siteUrl}cards/family?familyId=${encodeURIComponent(familyId)}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
    });
    return this._checkResponse(response);
  }
  async updateFamilyIdById(userId, familyId) {
    const response = await fetch(`${this._siteUrl}users/${userId}/family`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
      body: JSON.stringify({ familyId }),
    });
    return this._checkResponse(response);
  }
  async updatePrintingById(userId) {
    const response = await fetch(`${this._siteUrl}users/${userId}/printing`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
    });
    return this._checkResponse(response);
  }
  async updateClosedById(userId) {
    const response = await fetch(`${this._siteUrl}users/${userId}/closed`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
    });
    return this._checkResponse(response);
  }
  async updateAvatarById(userId, data) {
    const response = await fetch(`${this._siteUrl}users/${userId}/avatar`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
      body: JSON.stringify({ avatar: data.avatar }),
    });
    return this._checkResponse(response);
  }
  async updatePaidById(userId, hasPaid) {
    const url = `${this._siteUrl}users/${userId}/paid`;
    const options = {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
    };
    // If caller provided an explicit amount, send it. Otherwise omit body so server can set 0.
    if (typeof hasPaid !== 'undefined') {
      options.body = JSON.stringify({ hasPaid });
    }
    const response = await fetch(url, options);
    return this._checkResponse(response);
  }
  async updateProfileById(userId, { name, about }) {
    const response = await fetch(`${this._siteUrl}users/${userId}/updateprofile`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
      body: JSON.stringify({ name, about }),
    });
    return this._checkResponse(response);
  }

  async deleteUserById(userId) {
    const response = await fetch(`${this._siteUrl}users/${userId}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
    });
    return this._checkResponse(response);
  }
  constructor({ siteUrl }) {
    this._siteUrl = siteUrl;
  }

  _checkResponse(response) {
    if (response.ok) {
      return response.json();
    }
    return Promise.reject(`Ошибка: ${response.status}`);
  }

  async getAllUsers() {
    const response = await fetch(`${this._siteUrl}users`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
    });
    return this._checkResponse(response);
  }

  async getDroppedCarts() {
    const response = await fetch(`${this._siteUrl}users/dropped-cart`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
    });
    return this._checkResponse(response);
  }

  async getUserInfo() {
    //NOTE: принцип DRY.
    /*
     функции типа 
     await fetch(`${this._siteUrl}users/me`, {
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${localStorage.getItem('jwt')}`
      }
    })

    регулярно повторяются. Можно сделать метод, в котором будет указываться что-то уже по умолчанию, например:

    async commonFetch({endpoint: string, method: string, data?: any ... }) {
      const response = await fetch(`${this._siteUrl}${endpoint}`, {

      method: method || 'GET',
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${localStorage.getItem('jwt')}`
      },
      data
      })

      return response
    }
     */
    const response = await fetch(`${this._siteUrl}users/me`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
    });
    return this._checkResponse(response);
  }

  async deleteUser() {
    const response = await fetch(`${this._siteUrl}users/me`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
    });
    return this._checkResponse(response);
  }

  async setUserInfo(data) {
    const response = await fetch(`${this._siteUrl}users/me`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
      credentials: this._credentails,
      body: JSON.stringify({
        name: data.name,
        about: data.about,
      }),
    });
    return this._checkResponse(response);
  }

  async setUserAvatar(data) {
    const response = await fetch(`${this._siteUrl}users/me/avatar`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
      body: JSON.stringify({
        avatar: data.avatar,
      }),
    });
    return this._checkResponse(response);
  }

  async getServerCards() {
    const response = await fetch(`${this._siteUrl}cards`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
    });
    return this._checkResponse(response);
  }

  async handleAddNewCard(data) {
    const body = {
      name: data.name,
      link: data.link,
      isClassPhoto: data.isClassPhoto,
    };
    if (data.userId) body.userId = data.userId;
    const response = await fetch(`${this._siteUrl}cards`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
      body: JSON.stringify(body),
    });
    return this._checkResponse(response);
  }

  async deleteCard(cardId) {
    const response = await fetch(`${this._siteUrl}cards/${cardId}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
    });
    return this._checkResponse(response);
  }

  async setSmallPrintCounterUp(cardId) {
    const response = await fetch(
      `${this._siteUrl}cards/${cardId}/smallPrintCounterUp`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${localStorage.getItem("jwt")}`,
        },
      },
    );
    return this._checkResponse(response);
  }

  async setSmallPrintCounterDown(cardId) {
    const response = await fetch(
      `${this._siteUrl}cards/${cardId}/smallPrintCounterDown`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${localStorage.getItem("jwt")}`,
        },
      },
    );
    return this._checkResponse(response);
  }

  async setBigPrintCounterUp(cardId) {
    const response = await fetch(
      `${this._siteUrl}cards/${cardId}/bigPrintCounterUp`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${localStorage.getItem("jwt")}`,
        },
      },
    );
    return this._checkResponse(response);
  }

  async setBigPrintCounterDown(cardId) {
    const response = await fetch(
      `${this._siteUrl}cards/${cardId}/bigPrintCounterDown`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${localStorage.getItem("jwt")}`,
        },
      },
    );
    return this._checkResponse(response);
  }

  async setCardDownloadOption(cardId) {
    const response = await fetch(
      `${this._siteUrl}cards/${cardId}/downloadOption`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${localStorage.getItem("jwt")}`,
        },
      },
    );
    return this._checkResponse(response);
  }

  async setCardYearbookOption(cardId) {
    const response = await fetch(
      `${this._siteUrl}cards/${cardId}/yearbookOption`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${localStorage.getItem("jwt")}`,
        },
      },
    );
    return this._checkResponse(response);
  }

  async removeCardDownloadOption(cardId) {
    const response = await fetch(
      `${this._siteUrl}cards/${cardId}/downloadOption`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${localStorage.getItem("jwt")}`,
        },
      },
    );
    return this._checkResponse(response);
  }

  async removeCardYearbookOption(cardId) {
    const response = await fetch(
      `${this._siteUrl}cards/${cardId}/yearbookOption`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${localStorage.getItem("jwt")}`,
        },
      },
    );
    return this._checkResponse(response);
  }

  async changeDownloadOptionCardState(cardId, isDownloadOption) {
    if (isDownloadOption) {
      const response = await fetch(
        `${this._siteUrl}cards/${cardId}/downloadOption`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${localStorage.getItem("jwt")}`,
          },
          credentials: "include",
        },
      );
      return this._checkResponse(response);
    } else {
      const response = await fetch(
        `${this._siteUrl}cards/${cardId}/downloadOption`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${localStorage.getItem("jwt")}`,
          },
          credentials: "include",
        },
      );
      return this._checkResponse(response);
    }
  }

  async changeYearbookOptionCardState(cardId, isYearbookOption) {
    if (isYearbookOption) {
      const response = await fetch(
        `${this._siteUrl}cards/${cardId}/yearbookOption`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${localStorage.getItem("jwt")}`,
          },
          credentials: "include",
        },
      );
      return this._checkResponse(response);
    } else {
      const response = await fetch(
        `${this._siteUrl}cards/${cardId}/yearbookOption`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${localStorage.getItem("jwt")}`,
          },
          credentials: "include",
        },
      );
      return this._checkResponse(response);
    }
  }

  async getUserById(userId) {
    const response = await fetch(`${this._siteUrl}users/${userId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
    });
    return this._checkResponse(response);
  }

  async getCardsByUserId(userId) {
    const response = await fetch(`${this._siteUrl}cards/users/${userId}/cards`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
    });
    return this._checkResponse(response);
  }
}
//NOTE: siteUrl - сделать константой. Все подобные переменные вынести в отдельный файл constants.json и импортировать оттуда
export const api = new Api({ siteUrl: "https://myphotodelight.ru/api/" });
export default api;
// export const api = new Api({ siteUrl: 'https://api.myphotodelight.ru/' });
// export const api = new Api({ siteUrl: 'http://localhost:3001/api/' });
